import { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { connect } from "react-redux";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import TokenDetailReportCard from "../../components/report/TokenDetailReportCard";

const TokenDetail = ({ token, admin }) => {

	const history = useHistory();

	const location = useLocation();

	const [toggled, setToggled] = useState(false);

	useEffect(() => {
		if (!location.state || !admin || !admin.token_report) {
			history.push('/admin/dashboard')
		}
	}, [])

	const handleToggle = () => {
		setToggled(!toggled);
	}

	return (
		<div className="admin-page-container">
			<Sidebar toggled={toggled} setToggled={handleToggle} />
			<div className="admin-page">
				<Topbar handleToggle={handleToggle} />
				<div className="admin-content">
					<TokenDetailReportCard
						token={token}
					/>
				</div>
			</div>
		</div>
	);
}

const mapStateToProps = state => {
	return {
		admin: state.admin.admin,
		token: state.admin.token,
	};
};

export default connect(mapStateToProps, null)(TokenDetail);
